import { useState } from "react";
import { fmtTRY } from "../../lib/api";
import { Card, CardContent } from "../ui/card";
import { Tabs, TabsList, TabsTrigger } from "../ui/tabs";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import { CHART_COLORS } from "./constants";

const Stat = ({ label, value, testid, accent }) => (
  <Card className="border-slate-200">
    <CardContent className="p-3 sm:p-4">
      <div className="text-[10px] sm:text-[11px] uppercase tracking-widest font-bold text-slate-500">{label}</div>
      <div className={`text-sm sm:text-2xl font-extrabold mt-1 break-all ${accent}`} data-testid={testid}>{fmtTRY(value || 0)}</div>
    </CardContent>
  </Card>
);

export const ExpenseStats = ({ summary }) => (
  <div className="grid grid-cols-3 gap-2 sm:gap-3">
    <Stat label="Bugün" value={summary?.today} testid="exp-total-today" accent="text-rose-700" />
    <Stat label="Bu Ay" value={summary?.month} testid="exp-total-month" accent="text-rose-700" />
    <Stat label="Bu Yıl" value={summary?.year} testid="exp-total-year" accent="text-slate-900" />
  </div>
);

export const ExpenseCategoryChart = ({ summary }) => {
  const [range, setRange] = useState("month");
  const data = (range === "month" ? summary?.by_category_month : summary?.by_category_year) || [];
  return (
    <Card className="border-slate-200" data-testid="exp-category-chart">
      <CardContent className="p-4">
        <div className="flex items-center justify-between mb-2">
          <div className="font-bold text-slate-900">Kategori Dağılımı</div>
          <Tabs value={range} onValueChange={setRange}>
            <TabsList>
              <TabsTrigger value="month" data-testid="exp-chart-month">Bu Ay</TabsTrigger>
              <TabsTrigger value="year" data-testid="exp-chart-year">Bu Yıl</TabsTrigger>
            </TabsList>
          </Tabs>
        </div>
        {data.length === 0 ? (
          <div className="h-56 grid place-items-center text-sm text-slate-500">Bu dönemde gider yok.</div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 items-center">
            <div className="h-56">
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie data={data} dataKey="amount" nameKey="category" innerRadius={50} outerRadius={85} paddingAngle={2}>
                    {data.map((_, i) => <Cell key={i} fill={CHART_COLORS[i % CHART_COLORS.length]} />)}
                  </Pie>
                  <Tooltip formatter={(v) => fmtTRY(v)} />
                </PieChart>
              </ResponsiveContainer>
            </div>
            <ul className="space-y-1.5 text-sm max-h-56 overflow-y-auto">
              {data.map((d, i) => (
                <li key={d.category} className="flex items-center justify-between gap-2">
                  <span className="flex items-center gap-2 min-w-0">
                    <span className="h-2.5 w-2.5 rounded-full shrink-0" style={{ background: CHART_COLORS[i % CHART_COLORS.length] }} />
                    <span className="truncate">{d.category}</span>
                  </span>
                  <span className="font-semibold">{fmtTRY(d.amount)}</span>
                </li>
              ))}
            </ul>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
